angular.module('careerKeyCentral').directive('activityLogs', function() {
  var directive = {};
  directive.scope = false;
  directive.restrict = 'E'; /* restrict this directive to elements */
  directive.templateUrl = '/app/shared/views/partials/activityLogs.html';
  return directive;
});
